import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepFormData {
  [key: string]: any;
}

interface ChildSchoolFeeState {
  applicationId: string | null;
  formData: {
    step1: StepFormData;
    step2: StepFormData;
    step3: StepFormData;
  };
}

interface SaveFormDataPayload {
  applicationId: string;
  formData: StepFormData;
  step: 'step1' | 'step2' | 'step3';
}

const initialState: ChildSchoolFeeState = {
  applicationId: null,
  formData: {
    step1: {},
    step2: {},
    step3: {},
  },
};

export const mychildschoolfee = createSlice({
  name: 'mychildschoolfee',
  initialState,
  reducers: {
    saveMyChildSchoolFee: (
      state,
      action: PayloadAction<SaveFormDataPayload>
    ) => {
      const { applicationId, formData, step } = action.payload;
      state.applicationId = applicationId;
      state.formData[step] = formData;
    },
    clearMyChildSchoolForm: (state) => {
      state.applicationId = null;
      state.formData = { step1: {}, step2: {}, step3: {} };
    },
  },
});

export const { saveMyChildSchoolFee, clearMyChildSchoolForm } =
  mychildschoolfee.actions;
export default mychildschoolfee.reducer;
